module.exports = __webpack_public_path__ + "static/media/fold-orbit-tool.73a555fa.png";